<template>
	<img
		v-if="code && !loadFailed"
		:src="`/flags/${code.toUpperCase()}.svg`"
		:alt="code"
		@error="loadFailed = true"
	/>
	<!-- phosphor icon - flag, bold -->
	<svg v-else class="w-4 h-4" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 256 256">
		<path d="M40.14,46.88A12,12,0,0,0,36,56V224a12,12,0,0,0,24,0V181.72c22.84-17.12,42.1-9.12,70.68,5,16.23,8,34.74,17.2,54.8,17.2,14.72,0,30.28-4.94,46.38-18.88A12,12,0,0,0,236,176V56a12,12,0,0,0-19.86-9.07c-24.71,21.41-44.53,13.31-74.82-1.68C113.19,31.27,78.17,13.94,40.14,46.88ZM212,170.26c-22.84,17.13-42.1,9.11-70.68-5C118.16,153.76,90.33,140,60,153.87V61.69c22.84-17.12,42.1-9.12,70.68,5,16.23,8,34.74,17.2,54.8,17.2A63,63,0,0,0,212,78.08Z">
		</path>
	</svg>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';

const SUPPORTED_FLAGS = ['BE', 'BG', 'DE', 'ES', 'FR', 'GB', 'NL'] as const;
export type FlagCode = typeof SUPPORTED_FLAGS[number];

export default defineComponent({
	name: 'CountryFlag',
	props: {
		/**
		 * ISO country code.
		 * Supported: `BE`, `BG`, `DE`, `ES`, `FR`, `GB`, `NL`
		 */
		code: {
			type: String as PropType<FlagCode | (string & {}) | null>,
			default: null,
			validator: (value: string | null): boolean => {
				if (!value) return true;
				return SUPPORTED_FLAGS.includes(value.toUpperCase() as any);
			},
		},
	},

	data() {
		return {
			loadFailed: false,
		};
	},
});
</script>
